import { CartesianChart } from '@/common/dashboard/charts/CartesianChart';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { TreeUtils } from '@/common/utils/TreeUtils';
import { useEffect, useState } from 'react';

export const DirSaleGrossNetTrendChart = ({ formValues, totalProdIds }) => {
  const rsrc = useRsrc();

  const [data, setData] = useState();

  useEffect(() => {
    if (!formValues?.invPeriodId) {
      return;
    }

    const prodFilter = TreeUtils.smallestIdFilter(formValues.prodIds, totalProdIds);

    const reqParam = {
      invPeriodId: formValues.invPeriodId,
      prodIds: prodFilter.ids,
      prodIdsNot: prodFilter.not,
    };

    rsrc.data('sc', 'DIR_SALE_GROSS_NET_TREND_CHART_DATA_PLUGIN', reqParam).then((res) => {
      setData(res);
    });
  }, [formValues?.invPeriodId, formValues?.prodIds, totalProdIds]);

  return (
    <CartesianChart data={data} legend="bottom" markers yLabel="Sales Amount" xLabel="Invoice Period" allowNegative />
  );
};
